import React from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import DeviceComponent from '../components/DeviceComponent'
import SpeechConfig from '../../../../components/SpeechConfig'

function DeviceDashboardPage() {

    const deviceList = [
        {
            id:1,
            deviceName:"HP PC2",
            topicBase:"HPPC2/",
            title:"HP Laptop # 2",
        },
        
        {
            id:2,
            deviceName:"Mac",
            topicBase:"macbook1/",
            title:"Macbook M2 1",
        },

        {
            id:3,
            deviceName:"Redme",
            topicBase:"redme9a/",
            title:"Redme 9A",
        }
    ]

    return (
        <AppLayout>
            <div className="container-fluid">
                <SpeechConfig/>
                <div className="row flex-row-reverse">
                    {deviceList.map(device=>
                        <div className="col-md-4" key={device.id}>
                            <DeviceComponent  device={device} />
                        </div>
                    )}
                </div>
            </div>
        </AppLayout>
    )
}

export default DeviceDashboardPage